export default "__VITE_ASSET__64bcc512__"